export { InfoBox } from './InfoBox'
export type { InfoBoxProps } from './InfoBox'
